export const safeJsonParse = (value?: unknown): unknown => {
  try {
    return JSON.parse(value as unknown as string);
  } catch (err) {
    return value;
  }
};
